import { useSettingsStore } from "@/features/settings/hooks";
import { Select, SettingRow } from "@/features/settings/ui";

interface Props {
  className?: string;
}

/** 投稿パネル内で使用するお絵かきツール選択。 */
export const OekakiToolSetting: React.FunctionComponent<Props> = ({
  className,
}: Props) => {
  const oekakiTool = useSettingsStore((state) => state.oekakiTool);
  const setOekakiTool = useSettingsStore((state) => state.setOekakiTool);

  return (
    <SettingRow label="お絵かきツール" className={className}>
      <Select
        value={oekakiTool}
        onChange={(value: string): void =>
          setOekakiTool(value === "klecks" ? "klecks" : "axnos")
        }
        aria-label="お絵かきツール"
      >
        <option value="axnos">AXNOS</option>
        <option value="klecks">Klecks</option>
      </Select>
    </SettingRow>
  );
};
